import { Component, Input } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormField } from '../../form/formulary';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputText } from 'primeng/inputtext';
import { InputNumber } from 'primeng/inputnumber';
import { Textarea } from 'primeng/textarea';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-dynamic-form',
  imports: [
    ReactiveFormsModule,
    InputGroup,
    InputGroupAddon,
    InputText,
    InputNumber,
    Textarea,
    TranslatePipe,
  ],
  standalone: true,
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.css',
})
export class DynamicFormComponent {
  @Input() form!: FormGroup;
  @Input() fields: DynamicFormField[] = [];

  togglePasswordVisibility(input: HTMLInputElement): void {
    input.type = input.type === 'password' ? 'text' : 'password';
  }
}
